export default {
  loading: false,
  departments: [],
  departmentsOnlyDept:[],
  totalCount: 0,
};
